export default {
    /**
     * Set products
     *
     * @param {object} state    Vuex state.
     * @param {object} products Products list.
     */
    setProducts(state, products) {
        state.products = products;
    },
};
